import { DateInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import { SelectInput } from '@core/components/Select';
import { Collapse, Divider, Grid, IconButton, Tooltip } from '@material-ui/core';
import SelectImposto from 'app/components/Select/SelectImposto';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { MdHighlightOff } from 'react-icons/md';

const CompraRetencaoItem = ({
  id,
  name,
  index,
  errors,
  onChange,
  onBlur,
  values,
  touched,
  minDate,
  arrayHelpers,
  submitCount,
  showDivider,
  compraPaga,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const _errors = {
    imposto: (touched?.imposto || submitCount > 0) && errors?.imposto,
    valor: (touched?.valor || submitCount > 0) && errors?.valor,
    dataVencimento: (touched?.dataVencimento || submitCount > 0) && errors?.dataVencimento,
  };

  const handleRemove = () => {
    arrayHelpers.remove(index);
  };

  return (
    <Collapse in={open} onExited={handleRemove}>
      <div style={{ width: '100%' }}>
        <Grid className={clsx('mt-8', 'mb-8')} container spacing={3}>
          <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            <SelectImposto
              id={`${id}.imposto`}
              name={`${name}.imposto`}
              label="Imposto *"
              onChange={onChange}
              onBlur={onBlur}
              value={values?.imposto}
              touched={_errors?.imposto}
              error={_errors?.imposto}
              disabled={compraPaga}
            />
          </Grid>

          <Grid item xs={10} sm={2} md={2} lg={2} xl={2}>
            <DateInput
              id={`${id}.dataVencimento`}
              name={`${name}.dataVencimento`}
              onChange={onChange}
              onBlur={onBlur}
              value={values?.dataVencimento}
              error={!!_errors.dataVencimento}
              helperText={_errors.dataVencimento}
              touched={touched?.dataVencimento}
              required
              fullWidth
              variant="outlined"
              label="Data do vencimento"
              minDate={minDate}
              disabled={compraPaga}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <CurrencyTextField
              id={`${id}.valor`}
              name={`${name}.valor`}
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              maximumValue="999999999"
              minimumValue="0"
              decimalPlaces={2}
              decimalPlacesShownOnBlur={2}
              decimalPlacesShownOnFocus={2}
              error={!!_errors.valor}
              helperText={_errors.valor}
              onChange={(e, value) => {
                onChange({
                  target: {
                    id: `${id}.valor`,
                    value: e.target.value === '' ? '' : value,
                  },
                });
              }}
              onBlur={onBlur}
              value={values?.valor}
              fullWidth
              variant="outlined"
              label="Valor (R$) *"
              disabled={compraPaga}
              hideCurrencySymbol
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <SelectInput
              id={`${id}.contribuinte`}
              name={`${name}.contribuinte`}
              label="Contribuinte"
              onChange={onChange}
              value={values?.contribuinte}
              disableClearable
              options={[
                { id: 'EMPRESA', title: 'Empresa' },
                { id: 'FORNECEDOR', title: 'Fornecedor' },
              ]}
              disabled={compraPaga}
            />
          </Grid>
          <Grid item xs={1} sm={1} md={1} lg={1} xl={1} styles={{ display: 'flex', justifyContent: 'center' }}>
            {index > 0 && (
              <Tooltip title="Remover retenção" placement="right-end">
                <IconButton onClick={handleClose} disabled={compraPaga}>
                  <MdHighlightOff size={18} />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
        </Grid>
        {showDivider && <Divider />}
      </div>
    </Collapse>
  );
};

export default CompraRetencaoItem;
